/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
'use strict';

angular
  .module('http.metadataRestore', [])
  /**
   * Service used to get metadata restore data.
   */
  .factory('httpMetadataRestore', function ($http) {
    /**
     * Get the object counts for the restorable metadata component types.
     *
     * @param {Number} batchId - The batch id of the totals to list.
     * @returns {Promise} - A promise that resolves to an array of metadata backup details, one per component type.
     */
    function getComponentTypeTotals(batchId) {
      return $http({
        method: 'GET',
        url: 'api/metadata-backup/component-type-totals',
        params: {
          batchId: batchId
        }
      }).then(function (res) {
        return res.data;
      });
    }

    /**
     * Get the list of metadata items for a batch and component type.
     *
     * @param {Number} batchId - The batch id of the metadata to list.
     * @param {String} componentType - The type of component whose backups to list.
     * @returns {Promise} - A promise that resolves to an array of SfMetadataInfo objects for the specified component
     *   type.
     */
    function getItemsForBatchAndComponentType(batchId, componentType) {
      return $http({
        method: 'GET',
        url: 'api/metadata-backup/items',
        params: {
          batchId: batchId,
          componentType: componentType
        }
      }).then(function (res) {
        return res.data;
      });
    }

    /**
     * Get the component types and counts for each type
     *
     * @param {Number} batchId - The batch id
     * @returns {Promise} - A promise that resolves to an array of types and counts
     */
    function getSucessfulTypeTotals(batchId) {
      return $http({
        method: 'GET',
        url: 'api/metadata-restore/counts',
        params: {
          batchId: batchId
        }
      }).then(function (res) {
        return res.data;
      });
    }

    /**
     * Returns the component types we support for metadata restore
     *
     * @returns {string[]} - An array of component type names.
     */
    function getRestorableComponentTypes() {
      return $http({
        method: 'GET',
        url: 'api/metadata-restore/restorable-component-types',
        params: {}
      }).then(function (res) {
        return res.data;
      });
    }

    return {
      getItemsForBatchAndComponentType: getItemsForBatchAndComponentType,
      getComponentTypeTotals: getComponentTypeTotals,
      getSucessfulTypeTotals: getSucessfulTypeTotals,
      getRestorableComponentTypes: getRestorableComponentTypes
    };
  });
